import {
  Box,
  FormControl,
  FormHelperText,
  TextField,
  Typography,
} from '@mui/material'
import { BarcodeInspectionType } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { Controller } from 'react-hook-form'
import { useLabelFormContext } from '../LabelForm/LabelFormContext'
import { useAreaFormContext } from './AreaFormContext'
import { AutoReadButton } from './autoRead/AutoReadButton'
import { useBarcodeReader } from './autoRead/useAutoReader'

const barcodeRegex = /^[\x21-\x7E]*$/

export const BarcodeValue: FC = () => {
  const { control, formValues } = useAreaFormContext()
  const { formValues: labelFormValues } = useLabelFormContext()
  const { readBarcode, isLoading } = useBarcodeReader()

  const hasBBox = formValues.width > 0 && formValues.height > 0
  const isMatchType =
    formValues.barcodeInspectionType === BarcodeInspectionType.MATCH

  return (
    <Controller
      name="barcodeValue"
      control={control}
      rules={{
        required: isMatchType ? '1文字以上入力してください' : false,
        pattern: {
          value: barcodeRegex,
          message: '半角英数字と記号で入力してください',
        },
        maxLength: { value: 60, message: '60文字以内で入力してください' },
      }}
      render={({ field, fieldState: { error } }) => (
        <FormControl error={!!error} required sx={{ gap: 0.5 }}>
          <Typography
            component="label"
            sx={{ color: 'text.primary', fontSize: 14, fontWeight: 'bold' }}
          >
            バーコードの値
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-end' }}>
            <TextField
              {...field}
              required
              fullWidth
              error={!!error}
              sx={{ backgroundColor: 'white' }}
            />
            <AutoReadButton
              imageUrl={labelFormValues.imageUrl}
              bbox={{
                x: formValues.x,
                y: formValues.y,
                width: formValues.width,
                height: formValues.height,
              }}
              disabled={!hasBBox}
              isLoading={isLoading}
              successMessage="バーコードを読み取りました"
              onRead={value => field.onChange(value)}
              readFn={readBarcode}
            />
          </Box>
          {error ? (
            <FormHelperText sx={{ margin: 0 }}>{error.message}</FormHelperText>
          ) : (
            <Typography variant="caption" color="text.secondary">
              半角英数字と記号で入力してください（最大60文字）
            </Typography>
          )}
        </FormControl>
      )}
    />
  )
}
